import type { UploadedFileType, UploadFiles, UploadResult } from '../../types/files';

export function getFileFormatData(data: UploadFiles): UploadedFileType[] {
  if (!data) return [];

  const { success = [], rejected = [] } = data;
  const uploadFiles: UploadResult[] = [...success, ...rejected];

  return uploadFiles.map(({ file, status, value }) => {
    let url: string | null = null;
    if (value && value.uploaded) {
      url = value.uploaded.url;
    }
    return {
      fileName: file.name,
      name: file.name,
      url,
      contentType: file.type,
      type: file.type,
      status,
      size: file.size,
      uploadStatus: value?.uploaded?.checkResult,
    };
  });
}
